import { Menu, MenuProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledMenu = styled(Menu)<MenuProps>(({ theme }) => ({
  '& .MuiPaper-root': {
    width: 288,
    padding: '8px 16px',
    boxShadow: 'unset',
    border: `1px solid ${theme.palette.custom.grey9}`,
    borderRadius: '8px',
    backgroundColor: theme.palette.common.white,
  },
}));
